import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.01 12a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h1.323a1 1 0 0 0 .989-.855c.467-3.177.7-6.869.697-11.074-.003-4.222-.243-7.961-.72-11.216a1 1 0 0 0-.99-.855H34.01Zm4.268.565c.492 3.357.738 7.191.74 11.505.004 4.297-.235 8.085-.717 11.366A3 3 0 0 1 35.333 38H34.01a3 3 0 0 1-3-3V13a3 3 0 0 1 3-3h1.3a3 3 0 0 1 2.968 2.565Zm-24.154-1.053 15.232 9.52a3.5 3.5 0 0 1-.002 5.938l-15.252 9.519a3 3 0 0 1-4.57-2.212C9.175 31.073 8.998 27.67 9 24.063c.002-3.626.187-7.073.553-10.342a3 3 0 0 1 4.571-2.21Zm-1.479 1.55a1 1 0 0 1 .42.146l15.23 9.52a1.5 1.5 0 0 1 0 2.545l-15.252 9.52a1 1 0 0 1-1.523-.738c-.349-3.127-.522-6.456-.52-9.99.002-3.553.183-6.927.54-10.12a1 1 0 0 1 1.106-.883Z",
    fill: "currentColor"
  }));
};

var SvgSkipNext = styled(SvgComponent).withConfig({
  displayName: "SkipNext__SvgSkipNext",
  componentId: "sc-f9mmxp-0"
})(["", " ", ""], size, color);
export default SvgSkipNext;